import { useEffect, useState } from "react"

const tickersByMs = new Map<
    number,
    { intervalId: ReturnType<typeof setInterval>; listeners: Set<() => void> }
>()

function subscribe(ms: number, listener: () => void) {
    let ticker = tickersByMs.get(ms)
    if (!ticker) {
        const listeners = new Set<() => void>()
        const intervalId = setInterval(() => listeners.forEach((l) => l()), ms)
        ticker = { intervalId, listeners }
        tickersByMs.set(ms, ticker)
    }
    ticker.listeners.add(listener)
}

function unsubscribe(ms: number, listener: () => void) {
    const ticker = tickersByMs.get(ms)
    if (!ticker) return
    ticker.listeners.delete(listener)
    if (ticker.listeners.size === 0) {
        clearInterval(ticker.intervalId)
        tickersByMs.delete(ms)
    }
}

export function useTick(intervalMs: number | undefined) {
    const [, forceRender] = useState(0)
    useEffect(() => {
        if (intervalMs === undefined) return
        const listener = () => forceRender((n) => n + 1)
        subscribe(intervalMs, listener)
        return () => unsubscribe(intervalMs, listener)
    }, [intervalMs])
}
